import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { sgrColors } from '../../../../ui/sgr/SgrColors';

interface StatisticsSelectionCardProps {
  title: string;
  /** Short summary of the statistics available, shown in the card footer */
  description: string;
  /** Path to the logo image, relative to the public folder */
  iconSrc: string;
  link: string;
}

const StatisticsSelectionCard = ({
  title,
  description,
  iconSrc,
  link,
}: StatisticsSelectionCardProps) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '0.75rem !important',
        border: `1px solid ${sgrColors.grey_cloud}`,
        backgroundColor: '#ffffff',
        transition:
          'border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
        '&:hover': {
          borderColor: sgrColors.navy,
          boxShadow: '0 0.5rem 1.25rem rgba(0, 81, 157, 0.14)',
          transform: 'translateY(-0.125rem)',
        },
        '&:hover .selection-card-title': {
          color: sgrColors.navy,
        },
        '&:hover .selection-card-arrow': {
          opacity: 1,
          transform: 'translateX(0.25rem)',
        },
      }}
    >
      <CardActionArea
        component={RouterLink}
        to={link}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.25rem',
            padding: '1.25rem 1.5rem 0',
          }}
        >
          <Typography
            variant="h6"
            className="selection-card-title"
            sx={{
              fontWeight: 600,
              color: sgrColors.mine_shaft,
              transition: 'color 0.15s ease',
            }}
          >
            {title}
          </Typography>
          <ArrowForwardIcon
            className="selection-card-arrow"
            fontSize="small"
            sx={{
              color: sgrColors.navy,
              opacity: 0.4,
              transition: 'opacity 0.15s ease, transform 0.15s ease',
            }}
          />
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem',
          }}
        >
          <Box
            component="img"
            src={iconSrc}
            alt=""
            sx={{
              width: '5rem',
              height: '5rem',
              flexShrink: 0,
              objectFit: 'contain',
            }}
          />
        </Box>
        <Box
          sx={{
            borderTop: `1px solid ${sgrColors.grey_cloud}`,
            backgroundColor: sgrColors.frost_grey,
            padding: '0.875rem 1.25rem',
          }}
        >
          <Typography variant="body2" sx={{ color: sgrColors.backdrop }}>
            {description}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default StatisticsSelectionCard;
